/* eslint react-hooks/rules-of-hooks: "warn" */
import { getHotkeyMenu, HOTKEY_TYPE, useFramework } from '@/framework';
import { getLocaleStore } from '@/i18n';
import { IExportContextMenuItem, IRenderContextMenuItemArgs } from '../../../type';
import MenuItem from '../../../views/menu-item';

const render = ({ activeLayer, pickLayer }: IRenderContextMenuItemArgs) => {
    const { $t } = getLocaleStore();
    const framework = useFramework();
    const layer = pickLayer || activeLayer;
    let disabled = !layer;

    if (disabled) return null;
    if (activeLayer) {
        disabled = framework.getBehavior(activeLayer)?.checkDisableClone?.(activeLayer) ?? false;
    }

    const item = {
        disabled,
        name: $t((v) => v.contextMenuLayer.menuConfig.createCopy),
        type: HOTKEY_TYPE.createCopy,
        desc: getHotkeyMenu(HOTKEY_TYPE.createCopy),
        onClick: () => {
            framework.events.emit(HOTKEY_TYPE.createCopy);
        },
    };

    return <MenuItem {...item}></MenuItem>;
};

export default {
    group: 1,
    sort: 7,
    render,
} as IExportContextMenuItem;
